import React from 'react'

const SvgComponent = props => (
  <svg viewBox='0 0 31.38 31.31' {...props}>
    <g data-name='Layer 2'>
      <path
        d='M23.45 21.23a13.13 13.13 0 1 0-10.33 5 13.24 13.24 0 0 0 8.11-2.82l7.9 7.9 2.25-2.25zm-10.33 1.9a9.94 9.94 0 1 1 9.94-9.94 10 10 0 0 1-9.94 9.94z'
        fill='#f3f3f3'
        data-name='Layer 1'
      />
    </g>
  </svg>
)

export default SvgComponent



// WEBPACK FOOTER //
// ./src/components/UI/Icons/SearchIcon.js